module.exports = {
	"articleTitle1": "Ann Arbor Art Museum Guide ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "University of Michigan Museum of Art (UMMA)",
	"articleLink1": "https://www.michigandaily.com/section/arts/ann-arbor-art-museum-guide",
	"articleLink2": "https://www.michigandaily.com/section/campus-life/daily-umma-offers-free-memberships",
	"articleSnippet1": "Aug 12, 2015 ... Luckily for UMich students, admission to all campus art museums is free, but the \nenrichment is priceless. From UMMA's utterly Instagrammable ...",
	"articleSnippet2": "Jan 30, 2017 ... The University of Michigan Museum of Art is making memberships free, \naccording to an announcement made early Monday.The museum ...",
	"totalMisc": 1,
	"articleTitle2": "On the Daily: Art free of cost at UMMA ",
	"address": "525 S State St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/UmichArtMuseumORIONONLINE.jpg",
			"author": "File Photo",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160330/amc.FEA_.africanart.3.29.16.007_0.jpg?itok=y8bF6APw",
			"author": "Andrew Cohen",
			"caption": "LSA sophomore Julia Pompilius examines a Nigerian mask up close in UMMA's object study room for Art History professor David Doris's Yoruba Visual Culture class on Tuesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161104/elr.FEA_.copernicuslecture.11.2.16.1481.jpg?itok=MSVmeQqI",
			"author": "Emma Richter",
			"caption": "Robert Biedrón, LGBT activist and mayor of Slupsk, Poland, gives the Annual Copernicus Lecture at the University of Michigan Museum of Art on Wednesday."
		}
	],
	"position": {
		"lat": 42.2754,
		"lng": -83.7397
	},
	"tips": [
		{
			"text": "There's a room on the first floor that has great natural light for studying.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/umma.json
// module id = 995
// module chunks = 0